import QuotationList from './QuotationList';

export default QuotationList;
